import { graphql } from "../gql";

export const openStageTrackerBlockerMutationDoc = graphql(`
  mutation openStageTrackerBlocker($input: OpenStageTrackerBlockerInput!) {
    openStageTrackerBlocker(input: $input) {
      canChangeStage
      changeStageDisabledReason
      currentStageEnteredAt
      currentStage {
        id
        slug
        name
        description
        labelOrder
        sortOrder
        status
        type
      }
      blockers {
        id
        title
        description
        status
        canChangeSegment
        createdAt
        createdDuringStage {
          id
          slug
          name
          description
          labelOrder
          sortOrder
          status
          type
        }
        segments {
          id
          slug
          label
          status
        }
        segmentHistory {
          id
          enteredAt
          exitedAt
          context
          segment {
            id
            slug
            label
            status
          }
        }
      }
    }
  }
`);
